import Logo from './Logo';
import Navigation from './Navigation';

function Header() {

	return (
        <header>
            <Logo />
            <Navigation section=''/>
        </header>
    )
}

export default Header;
